import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=7bb967de&"
import script from "./MenuDropdown.vue?vue&type=script&lang=js&"
export * from "./MenuDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports